export default "/static/media/icon-trophy.21ba3011.svg";